export const allowedSubPreviews = ['note', 'loggedcall'];
